import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/system";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import {
  CorpTypeList1,
  Prefectures,
  Status,
} from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_CON024_Response, IAPI_CON026_Request } from "../../type/apiType";
import { httpAPI_CON024, httpAPI_CON026 } from "./api/request";
import { fakeTableList, schema } from "./parts";
import { facilitiesfields } from "../../assets/data/TkFacilitySelectionProperty";
import { TkGetCode } from "../../utils/TkGetCode";
import _ from "lodash";

/**
 * SCRC030001 社会福施設職員等退職手当共済制度　共済契約のお申込み
 * @return SCRC030001 社会福施設職員等退職手当共済制度　共済契約のお申込み
 */
const SCRC030001 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const userType = state.authInfo?.userType;

  const [isRegister, setIsRegister] = useState(true);
  const [openHoujin, setOpenHoujin] = useState(false);
  const [openKiko, setOpenKiko] = useState(false);
  const [showButton, setShowButton] = useState(true);

  const telRef = useRef("");
  const faxRef = useRef("");
  const managerTelRef = useRef("");

  const [statecorpInfoList, setStatecorpInfoList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [httpReq, setHttpReq] = useState<IAPI_CON026_Request>({
    corpName: "",
    corpNameKana: "",
    directorTitle: "",
    directorName: "",
    zipcode: "",
    prefectureCd: "",
    addressCity: "",
    businessOwnerClass: "",
    tel: "",
    mainFacilityKinds: "",
    managerDeptName: "",
    managerPosition: "",
    managerName: "",
    managerTel: "",
    managerEmail: "",
  });
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  // 経営者種別が「学校法人」の場合の初期表示
  useEffect(() => {
    let paramsData = queryParams.get("businessOwnerClass");
    let resArr = stateFakeTableList.current;
    let corpType = resArr.find(
      (item) => item.keyword === "businessOwnerClass"
    )!;

    if (paramsData === CorpTypeList1["学校法人"]) {
      corpType.disabled = true;
      corpType.setDefaultValue = CorpTypeList1["学校法人"];
    }

    // 申請idがある場合は、初期表示を行う
    if (location.state?.applyId) {
      handleInit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 初期表示
  const handleInit = async () => {
    try {
      const res = await httpAPI_CON024({
        applyId: location.state?.applyId,
      });

      if (res.resultCd === "I0000") {
        let resArr = stateFakeTableList.current;
        let needDis = false;

        const excludedStatuses = [Status["届出待ち"], Status["差戻し一時保存"]];
        if (!excludedStatuses.includes(res.latestApplyStatus as Status)) {
          setShowButton(false);
          needDis = true;
        } else {
          setShowButton(true);
          needDis = false;
        }

        resArr.forEach((item) => {
          item.disabled = needDis;

          if (item.keyword === "managerDeployment") {
            item.setDefaultValue = res["managerDeptName"];
            return;
          }

          if (item.keyword === "locationGroup") {
            item.valueObject = {
              prefectures: TkGetCode(Prefectures, res["prefectureCd"] ?? ""),
              city: res["city"] ?? "",
              address: res["addressOther"] ?? "",
            };
            return;
          }

          if (item.keyword === "emailConfirm") {
            item.setDefaultValue = res["managerEmail"];
            return;
          }

          if (item.keyword === "mainFacilityKinds") {
            item.setDefaultValue = res["facilityKind"];
            return;
          }

          item.setDefaultValue =
            res[item.keyword as keyof IAPI_CON024_Response];
        });

        setState({
          ...state,
          errorMsgId: "",
        });

        setStatecorpInfoList([...resArr]);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    let resArr = stateFakeTableList.current;

    let corpType = resArr.find(
      (item) => item.keyword === "businessOwnerClass"
    )!;
    const tel = resArr.find((item) => item.keyword === "tel")!;
    const fax = resArr.find((item) => item.keyword === "fax")!;
    const managerTel = resArr.find((item) => item.keyword === "managerTel")!;

    tel.onGetInputValue = (value: any) => {
      telRef.current = value.target.valueForShow;
    };

    fax.onGetInputValue = (value: any) => {
      faxRef.current = value.target.valueForShow;
    };

    managerTel.onGetInputValue = (value: any) => {
      managerTelRef.current = value.target.valueForShow;
    };

    let postcode = resArr.find((item) => item.keyword === "zipcode")!;

    // フォームの活性/非活性
    corpType.onGetValue = (data: any) => {
      let flg = data === CorpTypeList1["社会福祉法人"];
      corpType.isGuideMessage = !flg;
      setIsRegister(flg);
      resArr.forEach((item) => {
        if (item.keyword !== "businessOwnerClass") {
          item.disabled = !flg;
        }
      });
    };

    // 住所検索
    postcode.getPostalCodeValue = (value: any) => {
      const data = value.value;

      let resObj = {
        prefectures: data.address1,
        city: `${data.address2}${data.address3}`,
        address: "",
      };

      resArr.find((item) => item.keyword === "locationGroup")!.valueObject =
        resObj;

      setState({
        ...state,
        errorMsgId: "",
      });
    };

    postcode.getPostalCodeError = (value: any) => {
      setState({
        ...state,
        errorMsgId: value,
      });
    };

    setStatecorpInfoList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const makeHttpObj = (obj: any): IAPI_CON026_Request => {
    const {
      facilities: { AllFacilities },
    } = facilitiesfields;
    const targetMainFacilityKinds = AllFacilities.filter((item) =>
      obj.mainFacilityKinds.includes(item.id)
    );
    const reqObj: IAPI_CON026_Request = {
      corpName: obj.corpName,
      corpNameKana: obj.corpNameKana,
      corpNo: obj.corpNo,
      directorTitle: obj.directorTitle,
      directorName: obj.directorName,
      zipcode: obj.zipcode,
      prefectureCd:
        Prefectures[obj.locationGroup?.prefectures as keyof typeof Prefectures],
      addressCity: obj.locationGroup?.city,
      addressOthers: obj.locationGroup?.address,
      businessOwnerClass: obj.businessOwnerClass,
      mainFacilityKinds: targetMainFacilityKinds
        .map((item) => item.name)
        .join("、"),
      tel: telRef.current,
      fax: faxRef.current,
      managerDeptName: obj.managerDeployment,
      managerPosition: obj.managerPosition,
      managerName: obj.managerName,
      managerTel: managerTelRef.current,
      managerEmail: obj.managerEmail,
    };

    return reqObj;
  };

  const onCheckAndSubmit = (data: any) => {
    // 業務チェック
    if (data.managerEmail !== data.emailConfirm) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0001E",
      });
    } else {
      setState({
        ...state,
        errorMsgId: "",
      });
      setHttpReq({ ...makeHttpObj(data) });
      if (userType === authorityUserType.userTypeNumber.KIKO) {
        setOpenKiko(true);
      } else {
        setOpenHoujin(true);
      }
    }
  };

  const handleOk = async (date?: any) => {
    //共済契約申請書更新API実行
    try {
      const res = await httpAPI_CON026({
        ...httpReq,
        receptionDate: date,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }

      navigate("/SCRC070008", { state: { endPoint: true } });
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRC030001PageForTest">
      <TkFakeTable
        list={statecorpInfoList}
        ruleSchema={schema}
        onCheckAndSubmit={onCheckAndSubmit}
        disabled={!isRegister}
        submitButtonText={
          userType === authorityUserType.userTypeNumber.KIKO
            ? "申請"
            : "機構へ提出する"
        }
        showButton={showButton}
      />

      <TkMessageDialog
        open={openHoujin}
        onOky={handleOk}
        onCancel={() => setOpenHoujin(false)}
        title="確認（機構へ提出する）"
        contextText="　機構へ提出を行いますが、問題ないでしょうか。"
        cancelText="いいえ"
        okText="はい"
      />

      <TkDateDialog
        open={openKiko}
        onOky={handleOk}
        onCancel={() => setOpenKiko(false)}
        minDate={new Date("1900/01/01")}
        maxDate={new Date()}
        title="確認（申請）"
        contextText="　申請を行いますが、問題ないでしょうか。"
        cancelText="いいえ"
        okText="はい"
      />
    </Box>
  );
};

export default SCRC030001;
